(() => {
  'use strict';
  const setText = (element, value) => {
    if (!element) return;
    element.hidden = !value;
    element.textContent = value || '';
  };
  function initProduct(root) {
    if (root.dataset.initialized) return;
    const source = root.querySelector('[data-product-variants]');
    const select = root.querySelector('[data-variant-select]');
    if (!source || !select) return;
    let variants;
    try { variants = JSON.parse(source.textContent); } catch { return; }
    if (!Array.isArray(variants) || !variants.length) return;
    root.dataset.initialized = 'true';
    function update(updateHistory) {
      const variant = variants.find((item) => String(item.id) === select.value);
      const button = root.querySelector('[data-add-button]');
      if (!variant) {
        if (button) { button.disabled = true; button.textContent = 'Unavailable'; }
        return;
      }
      const price = root.querySelector('[data-product-price]');
      if (price) price.textContent = variant.price;
      setText(root.querySelector('[data-compare-price]'), variant.compareAtPrice);
      setText(root.querySelector('[data-unit-price]'), variant.unitPrice);
      const availability = root.querySelector('[data-availability]');
      if (availability) availability.textContent = variant.available ? 'Available' : 'Sold out';
      const quantity = Number(variant.inventory?.quantity);
      const tracked = variant.inventory?.managed && Number.isFinite(quantity) && quantity >= 0;
      setText(root.querySelector('[data-inventory-status]'), tracked ? `Inventory remaining: ${quantity}` : '');
      if (button) { button.disabled = !variant.available; button.textContent = variant.available ? 'Add to cart' : 'Sold out'; }
      const input = root.querySelector('[data-quantity-input]');
      if (input && variant.quantityRule) {
        const min = Number(variant.quantityRule.min) || 1;
        const step = Number(variant.quantityRule.increment) || 1;
        const max = Number(variant.quantityRule.max);
        const value = Number(input.value);
        input.min = String(min); input.step = String(step);
        if (Number.isFinite(max) && max > 0) input.max = String(max); else input.removeAttribute('max');
        if (!Number.isFinite(value) || value < min || (max > 0 && value > max) || (value - min) % step !== 0) input.value = String(min);
        const label = root.querySelector('[data-quantity-label]');
        if (label) label.textContent = min > 1 ? `Quantity (minimum ${min})` : 'Quantity';
      }
      if (updateHistory && root.dataset.enableHistory === 'true') {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }
    select.addEventListener('change', () => update(true));
    update(false);
  }
  function initGallery(gallery) {
    if (gallery.dataset.initialized) return;
    const buttons = [...gallery.querySelectorAll('[data-gallery-target]')];
    const panels = [...gallery.querySelectorAll('[data-gallery-panel]')];
    if (!buttons.length || !panels.length) return;
    gallery.dataset.initialized = 'true';
    function activate(button, focus = false) {
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.galleryPanel !== button.dataset.galleryTarget;
        if (panel.hidden) {
          panel.querySelectorAll('video').forEach((video) => video.pause());
          panel.querySelectorAll('iframe').forEach((frame) => {
            try {
              const host = new URL(frame.src).hostname;
              if (host.endsWith('youtube.com') || host.endsWith('youtube-nocookie.com')) frame.contentWindow?.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}), new URL(frame.src).origin);
              if (host === 'player.vimeo.com') frame.contentWindow?.postMessage({method:'pause'}, new URL(frame.src).origin);
            } catch { /* A media frame without a URL needs no command. */ }
          });
        }
      });
      buttons.forEach((candidate) => { candidate.setAttribute('aria-selected', String(candidate === button)); candidate.tabIndex = candidate === button ? 0 : -1; });
      if (focus) button.focus();
    }
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => activate(button));
      button.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % buttons.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + buttons.length) % buttons.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = buttons.length - 1;
        if (next !== undefined) { event.preventDefault(); activate(buttons[next], true); }
      });
    });
  }
  function init(root = document) {
    root.querySelectorAll('[data-product-root]').forEach(initProduct);
    root.querySelectorAll('[data-product-gallery]').forEach(initGallery);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true}); else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
